import { useState, type InputHTMLAttributes } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { useAppTranslation } from '../hooks/useAppTranslation.js';

type Props = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>;

/** Password field with an eye button that reveals the typed text. */
export function PasswordInput({ className = '', ...rest }: Props) {
  const { t } = useAppTranslation();
  const [visible, setVisible] = useState(false);
  return (
    <div className="relative">
      <input {...rest} type={visible ? 'text' : 'password'} className={`${className} pr-11`} />
      <button
        type="button"
        onClick={() => setVisible((v) => !v)}
        aria-label={visible ? t('common.hidePassword', 'Passwort verbergen') : t('common.showPassword', 'Passwort anzeigen')}
        aria-pressed={visible}
        tabIndex={-1}
        className="absolute inset-y-0 right-0 flex w-11 items-center justify-center text-ink-muted hover:text-ink"
      >
        {visible ? <EyeOff className="h-4 w-4" aria-hidden="true" /> : <Eye className="h-4 w-4" aria-hidden="true" />}
      </button>
    </div>
  );
}
